


























































import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import mixins from 'vue-typed-mixins';
import BuildEntityComponent from '@/Shared/CommonEntityMixins/EntityComponentMixin';
import { LookupsSystemVariables } from './LookupsSystemVariables';
import RadioToggle from '@/Shared/RadioToggle.vue';
import { AxiosResponse } from 'node_modules/axios';

const component = mixins(LocationBasedMixin, BuildEntityComponent<LookupsSystemVariables>()).extend({
    components: {
        RadioToggle
    },
    data() {
        return {
            i18nPrefix: 'admin.programVariables.lookups'
        };
    },
    computed: {
        entityUrls() {
            return `${this.location}/lookupsSystem/variables`;
        }
    },
    methods: {
        afterSave(response: AxiosResponse<LookupsSystemVariables>): LookupsSystemVariables {
            const translatedTitle = this.$i18n.t(`${this.i18nPrefix}.saveSuccessTitle`);
            const translatedMessage = this.$i18n.t(`${this.i18nPrefix}.saveSuccessMessage`);
            this.$bvToast.toast(translatedMessage.toString(), {
                title: translatedTitle.toString(),
                autoHideDelay: 5000
            });

            response.data.lookupsStartDate = new Date(response.data.lookupsStartDate);

            return response.data;
        },
        afterLoad(response: AxiosResponse<LookupsSystemVariables>): LookupsSystemVariables {

            response.data.lookupsStartDate = new Date(response.data.lookupsStartDate);

            return response.data;
        },
    }
});

export default component;
